const COPIES = {
    page_title: 'Freelance Economic Impact Report',
    page_text_part_1:
        'A growing number of Americans are choosing to pursue flexibility and autonomy in their career paths, fueling a substantial uptick in the number of freelancers around the country. For independent professionals ranging from AI consultants and architects to web developers and graphic designers, dissecting, quantifying, and fully grasping this segment of the workforce can pose a challenge. In collaboration with',
    page_text_link_text: ' Illuminas',
    page_text_part_2:
        ', this report continues to be a leading analysis of the size and growth of independent professionals across the country, as well as an interesting look at their population in specific metro areas.',
    page_text_part_3:
        'For the fourteenth year, Fiverr’s Freelance Economic Impact Report analyzes nearly 30 million tax returns from annually compiled Non-Employer U.S. Census Bureau statistics to explore the size, growth, and skills of independent professionals across the 30 largest metropolitan cities for independent knowledge-based work. This report is a crucial resource for understanding the opportunities for independent work and its impact on local metro areas, as well as for understanding the rising demand for this type of work.',
    page_footer_title: 'The Fourteenth Annual Freelance Economic Impact Report',
    page_footer_text_1:
        "We've partnered with Illuminas for the fourteenth annual Freelance Economic Impact Report. While our report focuses on the top 30 metropolitan cities, we believe there are many other areas of the U.S. that could benefit greatly from independent work, especially now as we've seen more opportunities for independent workers to join the online world.",
    page_last_year_report: 'Click Here to Download our %{year} Report',
    page_footer_text_2:
        'If interested in taking a look at our reports from previous years, you can download and view them below.',
    page_footer_old_year_report: '%{year} Report',
    info_title: '%{city} ranks #%{rank} among the fastest growing cities by population for independent professionals.',
    info_title_revenue: 'Independent Professionals Earnings %{year}: %{value}',
    info_title_population: 'Independent Professionals Population %{year}: %{value}',
    info_title_revenue_creative: 'Creative Workers: %{value}',
    info_title_revenue_technical: 'Technical Workers: %{value}',
    info_title_revenue_professional: 'Professional Workers: %{value}',
    info_title_population_creative: 'Creative Workers: %{value}',
    info_title_population_technical: 'Technical Workers: %{value}',
    info_title_population_professional: 'Professional Workers: %{value}',
    info_title_projections: '*Projections for %{years} based on U.S. GDP Growth',
    chart_title: 'Analyzing Population and Revenue Growth',
    chart_title_population: 'Population',
    chart_title_revenue: 'Revenue',
    back_button: 'All Cities',
    more_info: 'Click for more information',
    ranked_by: 'Ranked by',
};

export const getText = (key: keyof typeof COPIES, params?: Record<string, any>) => {
    const text = COPIES[key] || '';

    if (!params) {
        return text;
    }

    return Object.entries(params).reduce((text, [key, value]) => text.replace(`%{${key}}`, value), text);
};
